import React, { useEffect, useState } from "react";
import { Dialog } from "primereact/dialog";
import Loader from "../../../../components/loader";
import { toast } from "react-toastify";
import { toastOptObj } from "../../../../utils/constants";

interface StickerPreviewDialogProps {
    isOpen: boolean;
    tbsId: string;
    tbsNumber: string;
    issuedQty: number;
    onClose: () => void;
}

interface StickerImageEntity {
    id: string;
    imageUrl: string;
}

const StickerPreviewDialog: React.FC<StickerPreviewDialogProps> = ({
    isOpen,
    tbsId,
    tbsNumber,
    issuedQty,
    onClose,
}) => {
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [images, setImages] = useState<StickerImageEntity[]>([]);

    useEffect(() => {
        if (!isOpen) return;

        fetchStickerImages();
    }, [isOpen]);

    const fetchStickerImages = async (): Promise<void> => {
        try {
            setIsLoading(true);

            // TODO : Replace with API

            await new Promise((resolve) =>
                setTimeout(resolve, 600)
            );

            setImages([
                {
                    id: "1",
                    imageUrl:
                        "https://picsum.photos/700/450?random=1",
                },
                {
                    id: "2",
                    imageUrl:
                        "https://picsum.photos/700/450?random=2",
                },
                {
                    id: "3",
                    imageUrl:
                        "https://picsum.photos/700/450?random=3",
                },
                {
                    id: "4",
                    imageUrl:
                        "https://picsum.photos/700/450?random=4",
                },
            ]);
        } catch {
            toast.error(
                "Unable to load sticker images.",
                toastOptObj
            );
        } finally {
            setIsLoading(false);
        }
    };

    const handleDownloadAll = async (): Promise<void> => {
        try {
            setIsLoading(true);

            // TODO : Replace with Download API

            await new Promise((resolve) =>
                setTimeout(resolve, 500)
            );

            toast.success(
                "Download API will be integrated later.",
                toastOptObj
            );
        } catch {
            toast.error(
                "Unable to download stickers.",
                toastOptObj
            );
        } finally {
            setIsLoading(false);
        }
    };
    return (
        <>
            <Loader isLoading={isLoading} />

            <Dialog
                visible={isOpen}
                onHide={onClose}
                modal
                draggable={false}
                resizable={false}
                closable={false}
                style={{
                    width: "590px",
                    maxWidth: "95vw",
                }}
            >
                <div className="px-3 py-2">
                    <div className="d-flex justify-content-center align-items-center mb-2">
                        <h4 className="fw-bold mb-3">
                            Stickers – TBS {tbsNumber} ({images.length} pcs)
                        </h4>
                    </div>
                    {images.length === 0 ? (
                        <div
                            className="d-flex justify-content-center align-items-center text-muted"
                            style={{ height: "340px" }}
                        >
                            No Sticker Images Found
                        </div>
                    ) : (
                        <div className="row g-2">
                            {images.map((item) => (
                                <div
                                    key={item.id}
                                    className="col-6"
                                >
                                    <img
                                        src={item.imageUrl}
                                        alt={`Sticker ${item.id}`}
                                        className="img-fluid w-100 border"
                                    />
                                </div>
                            ))}
                        </div>
                    )}
                    <div className="row g-2 mt-2">
                        <div className="col">
                            <button
                                type="button"
                                className="btn btn-light border rounded-0  text-black w-100 py-2"
                                onClick={onClose}
                            >
                                Close
                            </button>
                        </div>

                        <div className="col">
                            <button
                                type="button"
                                className="btn btn-primary rounded-0 w-100 py-2"
                                onClick={handleDownloadAll}
                            >
                                Download All
                            </button>
                        </div>
                    </div>
                </div>
            </Dialog>
        </>
    );
};

export default StickerPreviewDialog;